import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47')
];

export const server_loads = [0];

export const dictionary = {
		"/": [~4],
		"/admin": [~5,[2]],
		"/admin/customer": [~6,[2]],
		"/admin/customer/newcustomer": [8,[2]],
		"/admin/customer/[customerId]": [~7,[2]],
		"/admin/forgot": [9,[2]],
		"/admin/menu": [~10,[2]],
		"/admin/menu/newmenu": [~12,[2]],
		"/admin/menu/[menuId]": [~11,[2]],
		"/admin/order": [~13,[2]],
		"/admin/order/neworder": [16,[2]],
		"/admin/order/[orderId]": [~14,[2]],
		"/admin/order/[orderId]/create-invoice": [~15,[2]],
		"/admin/reset": [17,[2]],
		"/admin/settings": [~18,[2]],
		"/admin/signin": [19,[2]],
		"/admin/signup": [20,[2]],
		"/admin/site-setting": [~21,[2]],
		"/admin/text": [~22,[2]],
		"/alergeny": [~23],
		"/animace": [24],
		"/auth": [25,[3]],
		"/auth/error": [26,[3]],
		"/cenik": [27],
		"/forgot": [28],
		"/gdpr": [29],
		"/haccp": [30],
		"/kontakt": [~31],
		"/kosik": [32],
		"/login": [33],
		"/mgr-bc-kamila-kucerova": [34],
		"/mgr-martin-forejt-phd": [35],
		"/obchodni-podminky": [36],
		"/obedy": [~37],
		"/olga-bednarova": [38],
		"/poradna": [39],
		"/prednasky-a-kurzy": [40],
		"/profile": [~41],
		"/reset": [42],
		"/signup": [43],
		"/signup/complete": [~44],
		"/test": [45],
		"/thankyou": [~46],
		"/version": [47]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';